import(/* webpackMode: "eager" */ "D:\\FekerTech\\Shahen Website New\\src\\app\\(home)\\page.jsx");
